<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="goreturn"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

    <!-- 选择 -->
    <div class="flex mgt-30 mgb-50">
      <div
        :class="selectActive == v.id ? 'topselectActive' : 'topselect'"
        v-for="v in select"
        :key="v.id"
        @click="selectBtn(v)"
      >
        {{ v.name }}
      </div>
    </div>

    <!-- 表单 -->

    <!-- 导表 -->
    <!-- 导入 -->
    <div v-if="selectActive == 2">
      <div class="color409eff cursor mgt-30" @click="download">
        下载Excle示例
      </div>
      <div class="fw-600 mgt-30 mgb-30">导入Excel</div>
      <el-upload
        ref="upload"
        :action="'#'"
        :limit="1"
        :multiple="false"
        :auto-upload="false"
        accept=".xls,.xlsx"
        :file-list="fileList"
        :http-request="uploadFile"
        :on-change="fileChange"
        :on-exceed="handleExceed"
        :on-remove="handleRemove"
      >
        <el-button size="small" type="primary" class="mgb-20"
          >文件浏览</el-button
        >
      </el-upload>
    </div>

    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="水卡编号" v-if="selectActive == 1" prop="card">
        <el-input v-model="form.card" placeholder="请输入水卡编号"></el-input>
      </el-form-item>
      <!-- <el-form-item label="起始卡号" v-if="selectActive == 2" prop="startCard">
        <el-input
          v-model="form.startCard"
          placeholder="请输入起始卡号"
        ></el-input>
      </el-form-item>
      <el-form-item label="终止卡号" v-if="selectActive == 2" prop="endCard">
        <el-input
          v-model="form.endCard"
          placeholder="请输入终止卡号"
        ></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="fenpei('form')">分配</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <div class="tableClass" v-if="tableData.length > 0">
      <el-table
        height="300"
        :data="tableData"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="cardId" label="卡号"> </el-table-column>
        <!-- <el-table-column prop="name" label="绑定状态"> </el-table-column> -->
        <el-table-column prop="msg" label="操作结果"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      select: [
        { id: 1, name: "单卡分配" },
        { id: 2, name: "批量分配" },
      ],
      selectActive: 1,
      form: {
        card: "",
        startCard: "",
        endCard: "",
      },
      rules: {
        card: [{ required: true, message: "请输入水卡编号", trigger: "blur" }],
        startCard: [
          { required: true, message: "请输入起始卡号", trigger: "blur" },
        ],
        endCard: [
          { required: true, message: "请输入终止卡号", trigger: "blur" },
        ],
      },
      tableData: [],
      zoneId: null,
      fileList: [],
      companyId: null,
    };
  },
  created() {
    this.zoneId = this.$route.query.zoneId;
    this.companyId = this.$route.query.companyId;
  },
  methods: {
    // 导表模板下载
    download() {
      this.$api.waterCard.template().then((res) => {
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(res);
        link.setAttribute("download", "导表模板.xls");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("file", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.zone
        .uploadCard({
          file: formData,
          regionId: this.zoneId,
        })
        .then((res) => {
          if (res.code === 200) {
            //   this.addVisible = false;
            // handleAlert("操作成功", "success");
            this.tableData = res.data;
          }
        });
      /* ------------------------------------ */

      // 成功失败都删除文件;
      this.fileList.splice(-1, 1);
    },
    /* 文件上传后的钩子  在此做校验 */
    fileChange(file, fileList) {
      this.file = file;
      // console.log(fileList);
      this.fileList = fileList;
      console.log(this.fileList, "已上传的");
      console.log(file, fileList, "第一个");
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (extension !== "xlsx" && extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx和xls的文件");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      // 文件大小校验
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        this.$message.warning("文件大小不得超过5M");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      this.fileName = file.name;
    },
    /* 超出个数 */
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 导入的文件删除
    handleRemove(file, fileList) {
      console.log(file, fileList, "删除");
    },
    fenpei(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          if (this.selectActive === 2 && this.fileList.length === 0) {
            handleAlert("请选择需要导入的文件", "error");
            return;
          }
          handleConfirm(
            `确认将水卡分配至该项目组吗?\n温馨提示:水卡分配项目组后,仅支持在项目组中设备内使用。`,
            "info"
          )
            .then(() => {
              if (this.selectActive === 1) {
                this.$api.zone
                  .oneBindCard({
                    cardNum: this.form.card,
                    regionId: this.zoneId,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      this.tableData = [];
                      this.tableData.push(res.data);
                    }
                  });
              } else {
                // this.$api.zone
                //   .moreBindCard({
                //     endCardId: this.form.endCard,
                //     startCardId: this.form.startCard,
                //     regionId: this.zoneId,
                //   })
                //   .then((res) => {
                //     if (res.code === 200) {
                //       this.tableData = res.data;
                //     }
                //   });
                this.$refs.upload.submit();
              }
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    selectBtn(v) {
      this.selectActive = v.id;
    },
    goreturn() {
      this.$router.push({
        path: "/zoneManage/zoneInfo",
        query: {
          zoneId: this.zoneId,
          companyId: this.companyId,
        },
      });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.topselect {
  width: 500px;
  height: 30px;
  background: var(--card-bg);
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.topselectActive {
  width: 500px;
  height: 30px;
  background: var(--accent);
  color: #fff;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.el-input,
.el-select {
  width: 300px !important;
}

.tableClass {
  margin-top: 200px;
  height: 300px;
  overflow-y: auto;
}
</style>
